import request from '@/utils/request'

// 查询标签列表
export function queryLabel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/label/queryLabel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加标签
export function saveLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/label/saveLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改标签
export function updateLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/label/updateLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除标签
export function deleteLabel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/label/deleteLabel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}